import React from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

const RootPage = ({ userAttributes: { isAdmin, isPsy, isDriver } }) => {
  if (isDriver) {
    return <Redirect to="/calendar" />;
  } else if (isPsy) {
    return <Redirect to="/drivers" />;
  } else if (isAdmin) {
    return <Redirect to="/users" />;
  }
  return <div>No role assigned to User</div>;
};

RootPage.propTypes = {
  userAttributes: PropTypes.object.isRequired,
};

export default RootPage;



// WEBPACK FOOTER //
// ./src/components/RootPage.js